import "./styles.less";

import React, { FC, useContext, useEffect, useState } from "react";
import { useFacebookPixel } from "../../../GlobalHooks/web/FacebookPixel.hook";
// import { useGoogleAnalytics } from "../../../GlobalHooks/web/GoogleAnalytics.hook";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import Cookies from "universal-cookie";

export const BannerSponsorSilver: FC = () => {
	const filtersData = useFilters();
	const operation_type_id = filtersData?.filters?.operation_type_id;
	let isBrowser = typeof window !== "undefined"
	let cookiepot = isBrowser ? new Cookies(document.cookie).get("cookiepot") : null;
	const eventsCategoryName: string = "sponsor_silver";
	// const GA = useGoogleAnalytics();
	const FP = useFacebookPixel();

	const { main_domain } = useContext(ConfigStateContext)
	const [data, setData] = useState(null)

	useEffect(() => {
		fetchRandomBanner()
	}, [])

	useEffect(() => {
		if (data?.sponsorSilver) {
			// GA.Event({
			// 	category: eventsCategoryName,
			// 	action: "show",
			// 	label: data?.sponsorSilver.readable_slug,
			// });
			FP.StandardEvent(eventsCategoryName);
		}
	}, [data]);

	const onClick = e => {
		if (data?.sponsorSilver) {
			// GA.Event({
			// 	category: eventsCategoryName,
			// 	action: "click",
			// 	label: data?.sponsorSilver.readable_slug,
			// });
			FP.StandardEvent(eventsCategoryName);
			if (e.ctrlKey || e.metaKey) return false;
		}
	};

	const fetchRandomBanner = async () => {
		try {
			const req = await fetch(process.env.graphQL_uri, {
				method: "POST",
				headers: {
					"x-origin": main_domain,
					"x-cookiepot": cookiepot ? cookiepot : "",
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					query: `{\n  sponsorSilver(operationType: ${operation_type_id ?? Math.floor(Math.random() * 2) + 1}) {\n    id\n    img\n    link\n    readable_slug\n  }\n}\n`
				})
			})
			const res = await req.json()
			setData(res.data)
		} catch (error) {
			console.warn('BannerSponsorSilver error: ', error)
		}
	}


	if (!data?.sponsorSilver) return null;
	return (
		<a
			href={data?.sponsorSilver.link}
			target="_blank"
			onClick={onClick}
			rel="nofollow"
			className={"sponsor-silver-banner"}>
			<img src={data?.sponsorSilver.img} alt={data?.sponsorSilver.readable_slug} />
		</a>
	);
};

